module.exports = __webpack_public_path__ + "media/images/result_sets/circles/7n8n5r1n-56bd01e73604e98fe36312c6ff7b3da3.svg";